import { HttpErrorResponse } from '@angular/common/http';
import { Observable, timer } from 'rxjs';
import { retry } from 'rxjs/operators';

export interface RetryConfig {
  maxRetries?: number;
  delay?: number;
}

export function retryOn409(config: RetryConfig = {}) {
  const { maxRetries = 3, delay = 500 } = config;

  return <T>(source: Observable<T>) =>
    source.pipe(
      retry({
        count: maxRetries,
        delay: (error: HttpErrorResponse, retryCount: number) => {
          // Retry on 409 Conflict, 502 Bad Gateway, and 503 Service Unavailable errors
          if (![409, 502, 503, 504].includes(error.status)) {
            throw error;
          }

          // Linear backoff: delay * retry attempt
          return timer(delay * retryCount);
        },
      })
    );
}
